/**
 * Set the height of each nav-top dropdown per item.
 */
export const setNavTopHeight = () => {

	document.querySelectorAll( '.c-nav-top__item--has-children' ).forEach( item => {

		const wrapper = item.querySelector( '.c-nav-top__wrapper' );

		if ( !wrapper ) {

			return;

		}

		item.style.setProperty( '--nav-top-dropdown-height', `${wrapper.scrollHeight}px` );

	} );

};
